import { Dialog, DialogContent, DialogHeading } from 'omakase';
import { consumer } from '@tock/coretypes';
import { disableBackgroundScroll, resumeBackgroundScroll } from 'utils/scrollUtils';
import { getTitleSuffix } from 'utils/seo';
import PrivateDiningRequestForm, { FormValues } from 'forms/PrivateDiningRequestForm';
import PureBaseComponent from '@tock/shared/components/PureBaseComponent';
import connect, { DefaultConnectProps, StoreType } from '@tock/shared/utils/connect';

export interface IPrivateDiningRequestForm {
  phoneCountryCode: string;
}

interface ConnectProps {
  app: StoreType['app'];
}

interface Props {
  onClose(): void;
  isWidget: boolean;
}

export class PrivateDiningRequestRoute extends PureBaseComponent<
  Props & ConnectProps & DefaultConnectProps
> {
  componentDidMount(): void {
    disableBackgroundScroll(document);
  }

  componentWillUnmount(): void {
    resumeBackgroundScroll(document);
  }

  async handleSubmit(formData: FormValues) {
    const { actions, onClose } = this.props;

    const values: Partial<consumer.PrivateDiningRequest> = {
      ...formData,
      phone: `${formData.phoneCountryCode} ${formData.phone}`,
    };

    await actions.privateDining.requestPrivateDining(values);
    setTimeout(() => {
      onClose();
    }, 1000);
  }

  render() {
    const { app, onClose } = this.props;
    const { patronProfile } = app;

    const business = app.config?.business;

    return (
      <>
        <Dialog open={true} onClose={onClose} variantDesktop="centered" fullHeight>
          <DialogHeading
            headingConfig={{
              right: {
                configType: 'closeButton',
              },
              left: {
                configType: 'title',
                title: `${business?.name} - Private Event Request${getTitleSuffix(business)}`,
              },
            }}
            onClose={onClose}
          />
          <DialogContent>
            <p className="PrivateDiningRequestModal-description">
              If you are interested in learning more about our offerings, please fill out the
              request form and we will contact you to discuss details.
            </p>

            <PrivateDiningRequestForm
              patronProfile={patronProfile || undefined}
              onSubmit={this.handleSubmit}
            />
          </DialogContent>
        </Dialog>
      </>
    );
  }
}

export default connect<Props>(PrivateDiningRequestRoute, ['app']);
